import { useEffect, useState, useCallback, useMemo } from 'react';
import {
  SimpleGrid,
  Spinner,
  Center,
  Text,
  Skeleton,
  Box,
  useColorModeValue,
} from '@chakra-ui/react';
import StatCard from './StatCard';
import { FaCity, FaLandmark, FaMapMarkedAlt, FaMap } from 'react-icons/fa';
import axios from 'axios';
import baseUrl from '../../../Base_Url/baseUrl';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';

const iconMap = {
  Division: FaCity,
  Districts: FaMapMarkedAlt,
  Tahsils: FaLandmark,
  Villages: FaMap,
};

const colorMap = {
  Division: { bgColor: '#ebf4ff', waveColor: '#3182ce', color: 'blue.600' },
  Districts: { bgColor: '#e6fffa', waveColor: '#319795', color: 'teal.500' },
  Tahsils: { bgColor: '#fefcbf', waveColor: '#d69e2e', color: 'yellow.600' },
  Villages: { bgColor: '#f0fff4', waveColor: '#38a169', color: 'green.600' },
};

const RegionStatsCards = () => {
  const MotionBox = motion(Box);
  const [rawStats, setRawStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const token = localStorage.getItem('token');
  const skeletonBg = useColorModeValue('white', 'gray.800');
  const borderColor = useColorModeValue('gray.200', 'gray.700');
  const fetchStats = useCallback(async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${baseUrl}/dashboard/region-counts`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.status) {
        setRawStats(response?.data?.data);
        setError('');
      } else {
        setError('Unexpected response status');
      }
    } catch (err) {
      setError('Failed to fetch region stats');
    } finally {
      setLoading(false);
    }
  }, [token]);

  const formattedStats = useMemo(() => {
    if (!rawStats) return [];
    const { divisions, districts, tahsils, villages } = rawStats;

    const rawList = [
      { label: 'Division', count: divisions },
      { label: 'Districts', count: districts },
      { label: 'Tahsils', count: tahsils },
      { label: 'Villages', count: villages },
    ];

    return rawList.map((stat) => ({
      ...stat,
      icon: iconMap[stat.label],
      ...colorMap[stat.label],
    }));
  }, [rawStats]);
  const navigate = useNavigate();
  useEffect(() => {
    fetchStats();
  }, [fetchStats]);

  if (loading) {
    return (
      <SimpleGrid columns={{ base: 1, sm: 2, md: 2, lg: 4 }} spacing="6">
        {Array.from({ length: 4 }).map((_, index) => (
          <Box
            key={index}
            p={{ base: 3, md: 4 }}
            borderWidth="1px"
            borderRadius="lg"
            boxShadow="md"
            bg={skeletonBg}
            borderColor={borderColor}
            minH={{ base: '140px', md: '170px' }}
          >
            <Skeleton height="24px" width="60px" mb="4" />
            <Skeleton height="28px" width="80%" mb="2" />
            <Skeleton height="20px" width="40%" />
          </Box>
        ))}
      </SimpleGrid>
    );
  }

  // if (error) {
  //   return (
  //     <Center h="200px">
  //       <Text color="red.500">{error}</Text>
  //     </Center>
  //   );
  // }

  return (
    <SimpleGrid columns={{ base: 1, sm: 2, md: 2, lg: 4 }} spacing="6">
      {formattedStats.map((stat, index) => (
        <MotionBox
          key={stat.label}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: index * 0.15 }}
        >
          <StatCard {...stat} onClick={() => navigate('/admin/regiondata')} />
        </MotionBox>
      ))}
    </SimpleGrid>
  );
};

export default RegionStatsCards;
